export default __webpack_public_path__ + "static/media/profile-placeholder.fa785003.png";